import {
  GETTING_ORDERS,
  GETTING_ORDERS_SUCCESS,
  GETTING_ORDERS_FAILURE,
  ACKING_PAYMENT,
  ACKING_SHIPPING,
} from "./actions";

const initialState = {
  orders: [],
  lastUpdated: new Date(),
};

export default function reducers(state = initialState, action) {
  switch (action.type) {
    case GETTING_ORDERS:
      return {
        ...state,
        lastUpdated: new Date(),
      };
    case GETTING_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.orders,
        lastUpdated: new Date(),
      };
    case GETTING_ORDERS_FAILURE:
      return {
        ...state,
        orders: action.orders,
        lastUpdated: new Date(),
      };
    case ACKING_PAYMENT:
      return {
        ...state,
        orders: action.orders,
        lastUpdated: new Date(),
      };
    case ACKING_SHIPPING:
      return {
        ...state,
        orders: action.orders,
        lastUpdated: new Date(),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers.js